export const getName = state => state.Contact.name;
export const getCity = state => state.Contact.city;
export const getEmail = state => state.Contact.email;
export const getTel = state => state.Contact.tel;
export const getSubject = state => state.Contact.subject;
export const getMessage = state => state.Contact.message;